import { AbsenceType } from '../../../../__generated__/graphql';

type AbsenceWithDates = {
  flair__Type__c?: AbsenceType;
  flair__Start_Date__c?: string | null;
  flair__End_Date__c?: string | null;
};

type AbsenceWithIsHourly = {
  isHourly: boolean;
  isMultiDay: boolean;
};

export const isMultiDayAndHourly = (
  absence: AbsenceWithDates | AbsenceWithIsHourly,
): boolean => {
  if ('isHourly' in absence && 'isMultiDay' in absence) {
    return Boolean(absence.isHourly && absence.isMultiDay);
  }

  if ('flair__Type__c' in absence) {
    return Boolean(
      absence.flair__Type__c === AbsenceType.Hourly &&
        absence.flair__Start_Date__c !== absence.flair__End_Date__c,
    );
  }

  return false;
};
